import React from 'react';
import PropTypes from 'prop-types';

import { Icon, Tooltip, Loader } from '@weezevent/nacre';
import Styles from '../../../styles/minisite/blocks.module.css';
import { Trans } from 'react-i18next';
import HTMLReactParser from 'html-react-parser';

export default function WidgetBlock({ block, onClick, handlePosition = () => {} }) {
    const [isLoading, setIsLoading] = React.useState(false);

    const handleClick = React.useCallback(() => {
        setIsLoading(true);
        onClick();
    }, [onClick]);

    if (!block) {
        return (
            <div className={`${Styles['create-content']} ${isLoading ? Styles['disabled-create-content'] : ''}`} onClick={handleClick}>
                {isLoading && <Loader inline />}
                <Icon name="edit" />
                <Trans i18nKey="ticket.event.minisite.block.add-block-widget" />
            </div>
        );
    }

    let renderData = HTMLReactParser(block.data);

    return (
        <div className={`${Styles['block-editable']} ${Styles['block-description']}`}>
            <span className={Styles['block-editable-delete']}>
                <span className={Styles['block-editable-ordering']}>
                    <Tooltip mini triggerOnHover title={<Trans i18nKey="ticket.event.minisite.position.down" />}>
                        <span className={Styles['block-editable-cta']} onClick={() => handlePosition(block, 1)}>
                            <Icon name="arrow-bottom" />
                        </span>
                    </Tooltip>
                    {block.position > 0 && (
                        <Tooltip mini triggerOnHover title={<Trans i18nKey="ticket.event.minisite.position.up" />}>
                            <span className={Styles['block-editable-cta']} onClick={() => handlePosition(block, -1)}>
                                <Icon name="arrow-top" />
                            </span>
                        </Tooltip>
                    )}
                </span>
            </span>
            {renderData}
        </div>
    );
}

WidgetBlock.propTypes = {
    block: PropTypes.object.isRequired,
    handlePosition: PropTypes.func
};
